import React, { useContext, useState } from "react";
import withAuth from "../utils/withAuth";
import { useNavigate } from "react-router-dom";
import "../App.css";
import {
  Button,
  IconButton,
  TextField,
  Box,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import RestoreIcon from "@mui/icons-material/Restore";
import { AuthContext } from "../contexts/AuthContext";

function HomeComponent() {
  let navigate = useNavigate();
  const [meetingCode, setMeetingCode] = useState("");
  const { addToUserHistory } = useContext(AuthContext);
  const theme = useTheme();

  // Responsive breakpoints
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));

  let handleJoinVideoCall = async () => {
    await addToUserHistory(meetingCode);
    navigate(`/${meetingCode}`);
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <Box
        className="navBar"
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginTop: { xs: "-50px" },
          padding: { xs: "10px 20px", sm: "10px 30px", md: "10px 40px" },
          paddingInline: { md: "100px" },
          flexDirection: { xs: "column", sm: "row" },
          gap: { xs: 2, sm: 0 },
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <img
            style={{
              width: isMobile ? "150px" : "200px",
              height: isMobile ? "150px" : "200px",
            }}
            src="/logo.png"
            alt="Logo"
          />
        </Box>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            margin: { xs: "-50px" },
            flexDirection: { sm: "row" },
            gap: { xs: 1, sm: 0 },
          }}
        >
          <IconButton
            onClick={() => navigate("/history")}
            sx={{
              display: "flex",
              alignItems: "center",
              flexDirection: "row",
            }}
          >
            <RestoreIcon />
            <Typography
              sx={{
                paddingRight: "20px",
                fontSize: { xs: "16px", sm: "18px", md: "20px" },
              }}
            >
              History
            </Typography>
          </IconButton>

          <Button
            sx={{
              fontWeight: "bold",
              color: "#D97500",
              border: "2px solid #D97500",
              borderRadius: "10px",
            }}
            onClick={() => {
              localStorage.removeItem("token");
              navigate("/auth");
            }}
          >
            Logout
          </Button>
        </Box>
      </Box>

      {/* Main Content */}
      <Box
        className="meetContainer"
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: "center",
          marginTop: { md: "-120px" },
          justifyContent: "center",
          flex: 1,
          padding: { xs: "20px", sm: "30px", md: "40px" },
          gap: { xs: 4, md: 2 },
        }}
      >
        {/* Left Panel */}
        <Box
          className="leftPanel"
          sx={{
            flex: { xs: "1", md: "1" },
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            maxWidth: { xs: "100%", md: "50%" },
            textAlign: { xs: "center", md: "left" },
            marginLeft: { md: "60px" },
            order: { xs: 2, md: 1 },
          }}
        >
          <Box>
            <Typography
              variant="h2"
              component="h2"
              sx={{
                fontSize: { xs: "1.5rem", sm: "2rem", md: "2.5rem" },
                marginBottom: "20px",
                fontWeight: "bold",
              }}
            >
              Providing Quality{" "}
              <span style={{ color: "#D97500" }}>Video Call</span> Just Like
              Quality Education
            </Typography>

            <Box
              sx={{
                display: "flex",
                gap: "10px",
                marginTop: "20px",
                flexDirection: { xs: "column", sm: "row" },
                justifyContent: { xs: "center", md: "flex-start" },
                alignItems: { xs: "center", sm: "flex-start" },
              }}
            >
              <TextField
                onChange={(e) => setMeetingCode(e.target.value)}
                id="outlined-basic"
                label="Meeting Code"
                variant="outlined"
                fullWidth={isMobile}
                sx={{ width: isMobile ? "100%" : "auto" }}
              />
              <Button
                sx={{
                  paddingInline: { xs: "20px", sm: "30px" },
                  backgroundColor: "#D97500",
                  borderRadius: "20px",
                  width: isMobile ? "100%" : "auto",
                }}
                onClick={handleJoinVideoCall}
                variant="contained"
              >
                Join
              </Button>
            </Box>
          </Box>
        </Box>

        {/* Right Panel */}
        <Box
          className="rightPanel"
          sx={{
            flex: { xs: "1", md: "1" },
            display: "flex",
            justifyContent: "center",
            maxWidth: { xs: "100%", md: "50%" },
            order: { xs: 1, md: 2 },
          }}
        >
          <img
            style={{
              maxWidth: "100%",
              height: "auto",
              width: isMobile ? "100%" : isTablet ? "400px" : "500px",
            }}
            src="/home.png"
            alt="Home illustration"
          />
        </Box>
      </Box>
    </Box>
  );
}

export default withAuth(HomeComponent);
